import { useCallback, useState } from "react";

import { ResetPasswordData, PasswordResetUIProps } from "./PasswordReset.types";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

export const usePasswordReset = (): PasswordResetUIProps => {
  const { onPasswordReset } = useLoginContext();

  const [validated, setValidated] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState<ResetPasswordData>({
    password: "",
    confirmPassword: "",
  });

  const handleShowPassword = useCallback(() => setShowPassword((prev) => !prev), []);
  const handleShowConfirmPassword = useCallback(() => setShowConfirmPassword((prev) => !prev), []);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setValidated(true);

      if (formData.password !== formData.confirmPassword) {
        return;
      }

      if (!e.currentTarget.checkValidity()) {
        return;
      }

      await onPasswordReset(formData.password);
    },
    [formData, onPasswordReset]
  );

  return {
    formData,
    validated,
    showConfirmPassword,
    showPassword,
    handleChange,
    handleShowConfirmPassword,
    handleShowPassword,
    handleSubmit,
  };
};
